import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useField } from 'formik';

import CustomLink from 'components/Common/CustomLink/CustomLink';
import PencilIcon from 'components/Common/Icons/Pencil';
import { getRoutesUri } from 'services/generic';
import { CustomeraddressType, CustomerType } from 'types/Customer';

import styles from './ShippingAddress.module.scss';

export type AddressType = {
  Primary: 'P';
  Secondary: 'S';
};

type Props = {
  fieldName: string;
  type: AddressType['Primary'] | AddressType['Secondary'];
  customer: CustomerType;
  address: CustomeraddressType;
};

export default function ShippingAddress({
  fieldName,
  type,
  customer,
  address,
}: Props): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const [{ value: fieldValue }, , { setValue }] = useField(fieldName);
  const isChecked = fieldValue === type;
  const title = {
    P: t('MAIN_ADDRESS_LABEL'),
    S: t('SECONDARY_ADDRESS_LABEL'),
  };

  const updateLink = {
    P: {
      label: t('UPDATE_MAIN_ADDRESS'),
      link: getRoutesUri('customerAccountAddressMainEdit') as string,
    },
    S: {
      label: t('UPDATE_SECONDARY_ADDRESS'),
      link: getRoutesUri('customerAccountAddressSecondaryEdit') as string,
    },
  };

  function onClickContainer(e: React.MouseEvent<HTMLDivElement>) {
    if ((e.target as HTMLDivElement).closest('a')) {
      return;
    }

    if (!isChecked) {
      setValue(type);
    }
  }

  return (
    <div className={styles.container} onClick={onClickContainer}>
      <Field
        type="radio"
        name={fieldName}
        value={type}
        id={`method-${type}`}
        className={styles.radio}
      />
      <div className={styles.information}>
        <div className={styles.title}>{title[type]}</div>
        <div className={styles.address}>
          <p>
            {customer.firstName} {customer.lastName}
          </p>
          <p>{address.nameComplement}</p>
          <p>{address.nameAddress}</p>
          <p>{address.street}</p>
          <p>{address.saidPlace}</p>
          <p>
            {address.postalCode} {address.city}
          </p>
        </div>
        <CustomLink
          to={updateLink[type].link}
          state={{ redirectShippingPage: true }}
          className={styles.editLink}
        >
          <PencilIcon />
          {updateLink[type].label}
        </CustomLink>
      </div>
    </div>
  );
}
